import { useMemo } from 'react';
import {
  useGetAdminNoticesQuery,
  useMarkAdminNoticeReadMutation,
} from '../../store/api/adminApi';
import { IS_TENANT_MODE } from '../../config/tenantMode';
import { isAuthenticated } from '../../utils/tokenManager';

/**
 * Shows Master-pushed admin notices (subscription / trial expiry) in tenant admin web.
 */
export function AdminNoticesBanner() {
  const auth = isAuthenticated();
  const enabled = IS_TENANT_MODE && auth;
  const { data } = useGetAdminNoticesQuery(undefined, {
    skip: !enabled,
    pollingInterval: enabled ? 120_000 : 0,
  });
  const [markRead] = useMarkAdminNoticeReadMutation();

  const unread = useMemo(
    () => (data?.items || []).filter((n) => !n.read).slice(0, 3),
    [data]
  );

  if (!enabled || unread.length === 0) return null;

  return (
    <div className="mb-4 space-y-2">
      {unread.map((n) => (
        <div
          key={n._id}
          className={`rounded-xl border px-4 py-3 text-sm ${
            n.type === 'subscription_expiry'
              ? 'border-amber-600/50 bg-amber-950/40 text-amber-100'
              : 'border-slate-600 bg-slate-900/60 text-slate-100'
          }`}
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="font-semibold">{n.title}</div>
              <div className="mt-1 whitespace-pre-line text-xs opacity-90">{n.body}</div>
            </div>
            <button
              type="button"
              className="shrink-0 rounded-lg bg-white/10 px-2 py-1 text-xs hover:bg-white/20"
              onClick={() => markRead(n._id)}
            >
              إخفاء
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
